import React, { useState} from "react"
import Footer from "../components/footer"
import { connect } from "react-redux"

const vid1 = `https://d975adv1u4h02.cloudfront.net/test/homevideo/NL_CANCIONERA.mp4`
const vid2 = `https://d975adv1u4h02.cloudfront.net/test/homevideo/AH_TRAILER.mp4`
const vid3 = `https://d975adv1u4h02.cloudfront.net/test/homevideo/AH_YCLL.mp4`
const vid4 = `https://d975adv1u4h02.cloudfront.net/test/homevideo/NL_CANTO.mp4`
const vid5 = `https://d975adv1u4h02.cloudfront.net/test/homevideo/AH_BESOS.mp4`
const vid6 = `https://d975adv1u4h02.cloudfront.net/test/homevideo/BRASIL.mp4`
const vid7 = `https://d975adv1u4h02.cloudfront.net/test/homevideo/YOAH.mp4`
const vid8 = `https://d975adv1u4h02.cloudfront.net/test/homevideo/BUKOWSKI.mp4`
const vid9 = `https://d975adv1u4h02.cloudfront.net/test/homevideo/JAROCHO.mp4`

const HomeVideo = props => {

  let vidStyle = {
    flex: `none`
  }

  let vidCont = {

    display: `flex`,
    justifyContent: `center`,
    height: props.height,
    overflow: `hidden`,

  }

  if (props.width > 1240) {

    vidCont = {
      width: props.width
    }

    vidStyle = {
      width: props.width
    }

  }

  // Final checklist order:
  // 1. NL CANCIONERA
  // 2. AH TRAILER
  // 3. AH YCLL
  // 4. NL UN CANTO POR MEXICO
  // 5. AH BESOS DE DESPEDIDA
  // 6. BRASIL
  // 7. COMUNIDAD INDIGENA
  // 8. BUKOWSKI
  // 9. JARANERO
  const vids = [vid1, vid2, vid3, vid4, vid5, vid6, vid7, vid8, vid9]

  const [vid, change] = useState(vids[0])

  const [chosen, changeIndex] = useState(0)

  const clicked = event => {
    event.preventDefault()

    changeIndex(event.target.id)

    change(vids[event.target.id])
        
  }

  return [ 

    <div style={vidCont}>
      <video key={vid} rel="preconnect" style={vidStyle} muted={props.mute} src={vid} loop autoPlay />,
    </div>,
    <Footer key={chosen} clickedIndex={chosen} length={vids.length} clicky={clicked} /> 
            
  ]

}

const mapStateToProps = (state) => {
    return {
        width: state.width,
        height: state.height,
        mute: state.mute
    }
  }
  
export default connect(mapStateToProps)(HomeVideo)
